<template>
  <div>
    <div v-if="isAdmin" class="p-2">
      <BatchOperations v-if="selectedMedia.length > 0" :media="selectedMedia" :network="network" @media-removed-from-network="filterOutSelectedMedia" />
      <span v-else>{{ $t('ListView.select-media-to-perform-batch-operations') }}</span>
    </div>
    <div class="media-list-view-table text-center">
      <table class="table">
        <thead ref="listViewHeader">
          <tr>
            <th v-if="isAdmin" scope="col" class="column1" style="width: 2%;"></th>
            <th scope="col" class="column2" style="width: 7%;">
              <i class="fas fa-file-video"></i>
              {{ $t('type') }}
            </th>
            <th scope="col" class="column3" style="width: 30%;">
              <i class="fas fa-text"></i>
              {{ $t('network.networkForm.title') }}
            </th>
            <th scope="col" class="column4" style="width: 18%;">
              <i class="fas fa-user"></i>
              {{ $t('presenter') }}
            </th>
            <th scope="col" class="column5" style="width: 14%;">
              <i class="fas fa-calendar-day"></i>
              {{ $t('network.networkForm.publishDate') }}
            </th>
            <th scope="col" class="column6" style="width: 11%;">
              <i class="fas fa-clock"></i>
              {{ $t('network.meeting.duration') }}
            </th>
            <th scope="col" class="column7" style="width: 10%;">
              <i class="fas fa-list-ol"></i>
              {{ $t('network.items')[0].toUpperCase() + $t('network.items').slice(1) }}
            </th>
            <th v-if="isAdmin" scope="col" class="column8" style="width: 10%;">
              {{ $t('network.member.action') }}
            </th>
          </tr>
        </thead>
        <tbody ref="listViewBody">
          <tr v-for="(m, index) in media" :key="index">
            <td v-if="isAdmin" scope="row">
              <input id="is_selected" v-model="m.is_selected" data-test="is_selected" type="checkbox" :disabled="m.type === 'collection'" class="me-2 d-inline-block" />
            </td>
            <td>
              <a v-if="m.type === 'video'">
                <i class="fas fa-2x fa-video"></i>
              </a>
              <a v-if="m.type === 'file'">
                <i class="fas fa-2x fa-file"></i>
              </a>
              <a v-if="m.isCollection">
                <i class="fas fa-2x fa-folder"></i>
              </a>
            </td>
            <td>
              <span v-if="m.type !== 'file'" role="button" @click="visitMedia(m)">{{ (m.title) }}</span>
              <a v-if="m.type === 'file'" class="d-inline-block">
                <strong role="button" @click="visitMedia(m)">{{ m.title }}</strong>
                <span v-if="m.url.download" role="button" class="ms-2" @click="downloadFile(m.url.download)">
                  <i class="text-info fas fa-download"></i>
                </span>
              </a>
            </td>
            <td>
              <span v-for="(p, i) in m.presenters.slice(0, m.presenters.length)" :key="'presenter-' + i">
                {{ p.name }}
                <b v-if="i != m.presenters.length - 1">&bullet;</b>
              </span>
            </td>
            <td>
              <span v-if="m.publish_date">
                <small>{{ formatDate(m.publish_date) }}</small>
              </span>
            </td>
            <td>
              <span v-if="!m.isCollection && m.type === 'video' && m.duration_seconds">
                {{ durationForHumans(m.duration_seconds) }}
              </span>
            </td>
            <td>
              <span v-if="m.collection_items" class="badge badge-pill bg-info ms-3">
                <i class="fas fa-sort-numeric-up"></i>
                {{ m.collection_items }}
              </span>
            </td>
            <td v-if="isAdmin">
              <span v-if="m.isCollection">
                <a :href="'/networks/collections/'+ m.slug +'/edit'" class="fw-semibold">
                  {{ $t('edit') }}
                </a>
              </span>
              <span v-else>
                <a :href="network ? ('/networks/'+ network.slug +'/media/'+ m.slug +'/edit') : (m.slug +'/edit')" class="fw-semibold" target="_blank">
                  {{ $t('edit') }}
                </a>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { durationForHumans } from '@/lib/util.js';
const BatchOperations = () => import('@/components/commons/Media/BatchOperations.vue');
import truncate from 'lodash/truncate';
import moment from 'moment';

export default {
  components: {
    BatchOperations: BatchOperations,
  },
  props: {
    media: {
      type: Array,
      default: null,
    },
    network: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isAdmin: false,
    };
  },
  computed: {
    selectedMedia() {
      return this.media.filter(m => m.is_selected);
    },
  },
  mounted() {
    if (this.$auth.auth) {
      if (this.network) {
        this.$http
          .get('networks/' + this.network.slug + '/members')
          .then(resp => {
            resp.data.data.filter(member => member.role_name === 'admin').forEach(member => {
              if (member.user_id === this.$auth.user.user_id || (this.$auth.auth && this.$auth.hasRole('super-admin'))) {
                this.isAdmin = true;
              }
            });
        });
      } else {
        if (this.$auth.auth && this.$auth.hasRole('super-admin')) {
          this.isAdmin = true;
        }
      }
    }
  },
  created() {
    window.addEventListener('scroll', this.stickyListViewHeader);
  },
  destroyed() {
    window.removeEventListener('scroll', this.stickyListViewHeader);
  },
  methods: {
    toggleMediaSelection(media) {
      media.is_selected = !media.is_selected;
    },
    filterOutSelectedMedia() {
      location.reload();
    },
    formatDate(date) {
      return moment(date).format('MM-DD-YYYY');
    },
    durationForHumans(seconds) {
      return durationForHumans(seconds);
    },
    visitMedia(m) {
      if (m.permission === 'authorized') {
        if (this.$auth.auth) {
          this.$router.push(m.url.view);
        } else {
          this.$bus.emit('show-sign-in', m.url.view, this.$t('auth.signInMessage.protectedMedia'));
        }
      } else {
        window.open(m.url.view, '_blank');
      }
    },
    downloadFile(link) {
      let msg = this.$t('network.downloadFileAlert');
      let action = () => {
        window.open(link, '_blank');
      };
      this.showConfirmPrompt(action, msg);
    },
    titleText(title) {
      return truncate(title, {
        length: 50,
        omission: '...',
      });
    },
    stickyListViewHeader() {
      var wrap = this.$refs.listViewHeader;
      if (window.top.scrollY > 160) {
        wrap.classList.add('fix-listview-header');
      } else {
        wrap.classList.remove('fix-listview-header');
      }
      // this.adjustWidth();
    },
    // adjustWidth() {
    //   this.$refs.listViewHeader.clientWidth = this.$refs.listViewBody.clientWidth;
    // },
  },
};
</script>
<style scoped>
.fix-listview-header {
  padding-right: unset !important;
}
.fix-listview-header .column1 {
  padding-right: 35px !important;
}
.fix-listview-header .column2,
.fix-listview-header .column3 {
  padding-right: 20px !important;
}
.fix-listview-header .column4,
.fix-listview-header .column5,
.fix-listview-header .column6 {
  padding-right: 0px !important;
}
.fix-listview-header .column7 {
  padding-right: 25px !important;
}
.table > :not(:last-child) > :last-child > * {
  border-bottom-color: inherit;
}
th {
  width: 150px;
  text-align: center;
  color: #5C6D80;
  font-weight: 600;
  font-size: 19px;
  line-height: 30px;
}
</style>